export * from './wall-type-9.component'